import {
    AppBar,
    Box,
    Modal,
    IconButton,
    Typography,
    Divider,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface ModalProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const DynamicModal = ({ open, handleClose, title, children }: ModalProps) => {
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <AppBar position="relative">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography py={1.5} px={2} variant="h6" color="inherit">
              {title}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon sx={{ color: 'white' }} />
            </IconButton>
          </Box>
        </AppBar>
        <Divider />
        <Box p={2}>{children}</Box>
      </Box>
    </Modal>
  );
};